import { Component, Input, OnInit, Pipe, PipeTransform, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms'
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PublicService } from 'src/app/services/public.service';
//import { DatabaseService } from 'src/app/services/database.service';
import {
  MatSnackBar,
  MatSnackBarConfig,
} from '@angular/material/snack-bar';

@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value: string) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@Component({
  selector: 'app-comment-box',
  templateUrl: './comment-box.component.html',
  styleUrls: ['./comment-box.component.css']
})
export class CommentBoxComponent implements OnInit {

  @Input()
  comment_data : any

  innerHtml = ''


  editorForm = new FormGroup({
    id : new FormControl(''),
    title: new FormControl(''),
    position: new FormControl(),
    youtube_id: new FormControl(''),
    inner_html: new FormControl('')
  });

  @ViewChild('editor') editor: any;
  config = {
    formula: true,
  }
  location_url!: string;


  ngOnChanges(changes: SimpleChanges) {
    //this.pService.getPosts({"username":this.comment_data.username, "blog_url": this.comment_data.blog_url})
    this.getAllPosts();

}

  postList!: any[];
  noteListFormControls = []
  noteListEditor = []

  @Input()
  path!: string;

 // constructor(private db : DatabaseService,private route_:Router) { }
  constructor(private route_:Router, private pService : PublicService,private snackBar: MatSnackBar) { }


  profile_url!: string;
  blog_url: any ; string: any;

  ngOnInit(): void {

    this.getAllPosts();
    this.location_url = "http://localhost:4200/blog/";
    var splitted = this.comment_data.blog_url.split("/", 2);
    this.profile_url = splitted[0];
    this.blog_url = splitted[1];

  }


  changeEditable(index:  number){
    this.noteListEditor[index] = !this.noteListEditor[index];
  }

  onSubmit(){
    // ADMIN
    var innerHtml = "";
    if (this.editorForm.get('editor')) {
      var r = this.editorForm.get('editor');
      if (r?.value) {
         innerHtml = r?.value;
      }
    }
    
    var re = /<img/gi;
    var newstr = innerHtml.replace(re, '<img class="img-fluid" width="500px"');
    this.innerHtml= newstr;
    console.log(this.innerHtml);

  }

  updateNote(index: string | number,id: any){
    var html = this.noteListFormControls[index].get('inner_html').value;
    var re1 = /<img class="img-fluid" width="500px"/gi;
    var newHtml1 = html.replace(re1, '<img');
    var re = /<img/gi;
    var newHtml = newHtml1.replace(re, '<img class="img-fluid" width="500px"');
    var update_data = {
      'id':id,
      'inner_html':newHtml,
      'title':this.noteListFormControls[index].get('title').value,
      'position':this.noteListFormControls[index].get('position').value,
      'youtube_id':this.noteListFormControls[index].get('youtube_id').value
    }

    if(true){
      this.pService.updatePost(update_data).subscribe(res=>{
        this.getAllPosts();
        this.showSnackBar("Post updated !!!","OK");

      },
      err =>{
        if(err.status == 404){
          this.showSnackBar("Can not completed !!!","OK");
        }else{
          this.showSnackBar("Something went wrong !!!","OK");
        }
      }
      )


    }else{
      alert('Update data size is too high !!!');
    }


  }

  deleteNote(id: any){
    //this.db.deleteNote(this.path,data);
    //this.snapshotChangeListner();
    this.pService.deletePost(id).subscribe(res=>{
      this.getAllPosts();
      this.showSnackBar("Post deleted !!!","OK");
    },
    err =>{
      if(err.status == 404){
        this.showSnackBar("Can not completed !!!","OK");
      }else{
        this.showSnackBar("Something went wrong !!!","OK");
      }
    }
    )
  }


  copyInputMessage(inputElement: { select: () => void; setSelectionRange: (arg0: number, arg1: number) => void; }){
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
  }



  createNote(){
    var html = this.editorForm.get('inner_html').value;
    var re = /<img/gi;
    var newHtml = html.replace(re, '<img class="img-fluid" width="500px"');


    var data = {
      'username': this.comment_data['username'],
      'blog_url': this.comment_data['blog_url'] ,
      'title':this.editorForm.get('title').value,
      'position':this.editorForm.get('position').value,
      'youtube_id':this.editorForm.get('youtube_id').value,
      'inner_html':newHtml
    }

    if(true){
      //this.db.createNote(this.path,data);
      var title = this.editorForm.get('title');
      title.reset();
      this.editorForm.get('position').reset();
      this.editorForm.get('youtube_id').reset();
      this.editorForm.get('inner_html').reset();
      //this.snapshotChangeListner();
      this.pService.createPost(data).subscribe(data=>{
        this.showSnackBar("Post created !!!","OK");
      },err=>{
        if(err.status==400){
          this.showSnackBar("can not complete !!!","OK");
        }else{
          this.showSnackBar("something went wrong !!!","OK");
        }
      }
      )
      this.getAllPosts();

      //window.location.reload();

    }else{
      alert('Size is too large !!!')
    }


  }


  snapshotChangeListner(){
    this.postList = []
    this.noteListFormControls = []
    this.noteListEditor = []
    /*
    this.db.getNotes(this.path).subscribe((res=>{
      this.noteList = res;
      this.noteList.forEach((note)=>{
        this.noteListFormControls.push(
          new FormGroup({
            editor: new FormControl(note.payload.doc.data().innerHTML),
            youtube_search: new FormControl(note.payload.doc.data().youtube_search),
            position: new FormControl(note.payload.doc.data().position)
          })
        )
        this.noteListEditor.push(false)
      })
    }))
    */
}

//   memorySizeOf(obj: { id?: any; inner_html: any; title: any; position: any; youtube_id: any; username?: any; blog_url?: any; }) {
//     var bytes = 0;
//     function sizeOf(obj: { [x: string]: any; length: number; hasOwnProperty: (arg0: string) => any; toString: () => { (): any; new(): any; length: number; }; } | null | undefined) {
//         if(obj !== null && obj !== undefined) {
//             switch(typeof obj) {
//             case 'number':
//                 bytes += 8;
//                 break;
//             case 'string':
//                 bytes += obj.length * 2;
//                 break;
//             case 'boolean':
//                 bytes += 4;
//                 break;
//             case 'object':
//                 var objClass = Object.prototype.toString.call(obj).slice(8, -1);
//                 if(objClass === 'Object' || objClass === 'Array') {
//                     for(var key in obj) {
//                         if(!obj.hasOwnProperty(key)) continue;
//                         sizeOf(obj[key]);
//                     }
//                 } else bytes += obj.toString().length * 2;
//                 break;
//             }
//         }
//         return bytes;
//     };
//     return sizeOf(obj);
// };

showSnackBar(msg:string,label:string) {
  let config = new MatSnackBarConfig();
  config.duration = 20000;
  this.snackBar.open(msg, label, config);
}

  getAllPosts(){
   this.pService.getPosts({"username":this.comment_data["username"],"blog_url":this.comment_data["blog_url"]}).subscribe(res=>{
      this.postList = res;
      this.postList.forEach((note: { id: any; title: any; position: any; youtube_id: any; inner_html: any; })=>{
        this.noteListFormControls.push(
          new FormGroup({
            id : new FormControl(note.id),
            title : new FormControl(note.title),
            position: new FormControl(note.position),
            youtube_id: new FormControl(note.youtube_id),
            inner_html: new FormControl(note.inner_html),
          })
        )
        this.noteListEditor.push(false)
      })
  },
    err=>{
      if(err.status==400){
        this.showSnackBar("can not complete !!!","OK");
      }else{
        this.showSnackBar("something went wrong !!!","OK");
      }
    }
  )
  }




  updatePost(){
    this.pService.getPosts({"username":this.comment_data["username"],"blog_url":this.comment_data["blog_url"]}).subscribe(data=>{
     this.postList = data;
     this.postList.forEach((note: { id: any; title: any; position: any; youtube_id: any; inner_html: any; })=>{
       this.noteListFormControls.push(
         new FormGroup({
           id : new FormControl(note.id),
           title : new FormControl(note.title),
           position: new FormControl(note.position),
           youtube_id: new FormControl(note.youtube_id),
           inner_html: new FormControl(note.inner_html),
         })
       )
       this.noteListEditor.push(false)
     })
   })
   }

}
